import { LegalLayout } from "../components/LegalLayout";
import { usePageSEO } from "../hooks/usePageSEO";

export default function Datenschutz() {
  usePageSEO({
    title: "Datenschutz — Alphalane Trading Systems",
    description: "Datenschutzerklärung von Alphalane Trading Systems. Erfahre, wie wir mit deinen personenbezogenen Daten umgehen.",
    canonical: "https://alphalane-tradingsystems.com/datenschutz",
  });
  return (
    <LegalLayout title="Datenschutzerklärung" lastUpdated="Februar 2026">
      <p>
        Wir legen grossen Wert darauf, dass der Umgang mit Personendaten transparent ist. Diese Datenschutzerklärung gibt
        Auskunft darüber, welche personenbezogenen Daten wir sammeln, zu welchem Zweck und an wen wir sie weitergeben. Um eine
        hohe Transparenz zu gewährleisten, wird diese Datenschutzerklärung regelmässig überprüft und aktualisiert.
      </p>

      <h2>1. Verantwortlich</h2>
      <p>
        Verantwortliche Stelle im Sinne der Datenschutzgesetze, insbesondere der EU-Datenschutzgrundverordnung (DSGVO), ist:
      </p>
      <p>
        Pascal Schwab<br />
        kontakt@moonshine-solutions.com<br />
        +41&nbsp;79&nbsp;950&nbsp;16&nbsp;46
      </p>

      <h2>2. Kontaktinformationen</h2>
      <p>
        Bei Fragen oder Anliegen zum Schutz Ihrer Daten erreichen Sie uns jederzeit per E-Mail unter
        <a href="mailto:kontakt@moonshine-solutions.com"> kontakt@moonshine-solutions.com</a>. Verantwortlich für die
        Datenbearbeitungen, die über diese Website erfolgen, ist:
      </p>
      <p>
        <strong>Moonshine Solutions GmbH</strong><br />
        Venusweg 42<br />
        3185 Schmitten FR<br />
        Schweiz<br />
        kontakt@moonshine-solutions.com
      </p>

      <h2>3. Allgemeine Grundsätze</h2>

      <h3>3.1 Welche Daten sammeln wir und von wem erhalten wir diese Daten?</h3>
      <p>
        In erster Linie bearbeiten wir Personendaten, die Sie uns übermitteln oder die wir beim Betrieb unserer Website sammeln.
        Unter Umständen erhalten wir Personendaten über Sie auch von Dritten. Das können folgende Kategorien sein:
      </p>
      <ul>
        <li>Personenstammdaten (Name, Adresse, Geburtsdaten, etc.)</li>
        <li>Kontaktdaten (Handynummer, E-Mail-Adresse, etc.)</li>
        <li>Finanzdaten (bspw. Kontoangaben)</li>
        <li>Onlinekennungen (bspw. Cookie-Kennung, IP-Adressen)</li>
        <li>Standort- und Verkehrsdaten</li>
        <li>Ton- und Bildaufnahmen</li>
        <li>besonders schützenswerte Daten (bspw. biometrische Daten oder Angaben über Ihre Gesundheit)</li>
      </ul>

      <h3>3.2 Unter welchen Voraussetzungen bearbeiten wir Ihre Daten?</h3>
      <p>
        Wir behandeln Ihre Daten vertraulich und gemäss den in dieser Datenschutzerklärung festgelegten Zwecken. Wir achten dabei
        auf eine transparente und verhältnismässige Bearbeitung. Falls wir ausnahmsweise nicht in der Lage sind, diese Grundsätze
        zu befolgen, kann die Datenbearbeitung trotzdem rechtmässig sein, weil ein Rechtfertigungsgrund vorliegt:
      </p>
      <ul>
        <li>Ihre Einwilligung</li>
        <li>die Durchführung eines Vertrages oder vorvertraglicher Massnahmen</li>
        <li>unsere berechtigten Interessen, sofern Ihre Interessen nicht überwiegen</li>
      </ul>

      <h3>3.3 Wie können Sie Ihre Einwilligung widerrufen?</h3>
      <p>
        Haben Sie uns eine Einwilligung zur Bearbeitung Ihrer personenbezogenen Daten für bestimmte Zwecke erteilt, bearbeiten
        wir Ihre Daten im Rahmen dieser Einwilligung, soweit wir keinen anderen Rechtfertigungsgrund haben. Sie haben jederzeit
        die Möglichkeit, Ihre Einwilligung zu widerrufen, indem Sie eine E-Mail an die im Impressum genannte Adresse schicken.
        Bereits erfolgte Datenverarbeitungen sind davon nicht betroffen.
      </p>

      <h3>3.4 In welchen Fällen können wir Ihre Daten an Dritte weitergeben?</h3>
      <p>
        Wir sind unter Umständen darauf angewiesen, die Dienste Dritter oder von verbundenen Unternehmen in Anspruch zu nehmen
        und diese mit der Verarbeitung Ihrer Daten zu beauftragen (sog. Auftragsverarbeiter). Kategorien der Empfänger sind
        namentlich:
      </p>
      <ul>
        <li>Buchhaltung, Treuhand und Revisionsunternehmen</li>
        <li>Beratungsunternehmen (Rechtsberatung, Steuern, etc.)</li>
        <li>IT-Dienstleister (Webhosting, Support, Clouddienste, Webseitengestaltung, etc.)</li>
        <li>Zahlungsdienstleister</li>
      </ul>
      <p>
        Wir stellen sicher, dass diese Dritten die Voraussetzungen des Datenschutzes einhalten und Ihre personenbezogenen Daten
        vertraulich behandeln. Unter Umständen sind wir auch verpflichtet, Ihre personenbezogenen Daten an Behörden bekanntzugeben.
      </p>
      <p>
        <strong>Weitergabe ins Ausland:</strong> Im Rahmen der Auftragsbearbeitung kann es zur Übermittlung Ihrer Daten an
        Unternehmen im Ausland kommen. Diese Unternehmen sind im gleichen Umfang zum Datenschutz verpflichtet wie wir selbst.
        Entspricht das Datenschutzniveau nicht demjenigen der Schweiz, so nehmen wir eine vorgängige Risikoeinschätzung vor und
        stellen vertraglich sicher, dass der gleiche Schutz wie in der Schweiz garantiert wird (bspw. mittels der Standardvertragsklauseln
        der EU-Kommission).
      </p>

      <h3>3.5 Wie lange bewahren wir Ihre Daten auf?</h3>
      <p>
        Wir speichern personenbezogene Daten nur so lange, wie dies erforderlich ist, um die einzelnen Zwecke, zu denen die Daten
        erhoben wurden, zu erfüllen. Daten, die wir bei Ihrem Besuch auf unserer Website speichern, werden während zwölf Monaten
        aufbewahrt. Vertragsdaten speichern wir länger, da wir dazu durch gesetzliche Vorschriften verpflichtet sind. Wir müssen
        insbesondere geschäftliche Kommunikation, geschlossene Verträge und Buchungsbelege bis zu 10 Jahren aufbewahren.
      </p>

      <h3>3.6 Wie schützen wir Ihre Daten?</h3>
      <p>
        Wir bewahren Ihre Daten sicher auf und ergreifen alle angemessenen Massnahmen, um Ihre Daten vor Verlust, Zugriff,
        Missbrauch oder Änderungen zu schützen. Innerhalb unserer Webseite verwenden wir das SSL-Verfahren (Secure Socket Layer)
        in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird.
      </p>

      <h3>3.7 Welche Rechte haben Sie?</h3>
      <ul>
        <li><strong>Auskunftsrecht:</strong> Sie können jederzeit Auskunft über die von uns über Sie gespeicherten Daten verlangen.</li>
        <li><strong>Löschung und Berichtigung:</strong> Sie können jederzeit die Löschung oder Berichtigung Ihrer Daten verlangen.</li>
        <li><strong>Datenübertragbarkeit:</strong> Sie haben das Recht, Ihre Daten in einem gängigen Dateiformat zu erhalten.</li>
        <li><strong>Rechtsweg:</strong> Sie haben das Recht, Ihre Rechte gerichtlich durchzusetzen oder bei der zuständigen Aufsichtsbehörde eine Meldung einzureichen. Die zuständige Aufsichtsbehörde in der Schweiz ist der <a href="https://www.edoeb.admin.ch" target="_blank" rel="noopener noreferrer">Eidgenössische Datenschutz- und Öffentlichkeitsbeauftragte</a>.</li>
      </ul>
      <p>
        Wir bitten Sie, Ihr Auskunftsgesuch zusammen mit einem Identitätsnachweis an
        <a href="mailto:kontakt@moonshine-solutions.com"> kontakt@moonshine-solutions.com</a> zu senden.
      </p>

      <h3>3.8 Änderungen an der Datenschutzerklärung</h3>
      <p>
        Wir können diese Datenschutzerklärung jederzeit ändern. Die Änderungen werden auf dieser Seite veröffentlicht.
      </p>

      <h2>4. Einzelne Datenverarbeitungsvorgänge</h2>

      <h3>4.1 Bereitstellen der Webseite und Erstellung von Logfiles</h3>
      <p>
        Beim Besuch unserer Website werden auf unseren Servern oder auf Servern von Dienstleistungen, die wir beziehen, bestimmte
        Daten automatisch gespeichert. Es handelt sich dabei um:
      </p>
      <ul>
        <li>den Namen Ihres Internetserviceproviders</li>
        <li>Ihre IP-Adresse (unter Umständen)</li>
        <li>die Version Ihrer Browser-Software</li>
        <li>das Betriebssystem des Rechners</li>
        <li>das Datum und die Uhrzeit des Zugriffs</li>
        <li>die Webseite, von der aus Sie unsere URL besuchen</li>
      </ul>
      <p>
        Diese Daten können keiner bestimmten Person zugeordnet werden. Die Speicherung erfolgt zur Garantie der Funktionsfähigkeit
        der Webseite und zur Sicherstellung der Sicherheit unserer informationstechnischen Systeme. Hierin besteht unser
        berechtigtes Interesse.
      </p>

      <h3>4.2 Kontaktformular</h3>
      <p>
        Wenn Sie das Kontaktformular auf dieser Website nutzen, werden die von Ihnen eingegebenen Daten (Name, E-Mail-Adresse,
        Telefonnummer, geplante Investmentgröße, Nachricht) ausschliesslich zum Zweck der Bearbeitung Ihrer Anfrage gespeichert
        und verarbeitet. Rechtsgrundlage: Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO (Anbahnung eines Vertragsverhältnisses)
        bzw. lit.&nbsp;f DSGVO (berechtigtes Interesse an der Beantwortung Ihrer Anfrage).
      </p>

      <h3>4.3 Google Fonts API</h3>
      <p>
        Auf unserer Website nutzen wir die Google Fonts API, einen Dienst der Google LLC (1600 Amphitheatre Parkway,
        Mountain View, CA 94043, USA), um Schriftarten einzubinden. Durch die Einbindung wird Ihr Browser eine Verbindung zu
        den Servern von Google herstellen. Dabei können Daten, insbesondere Ihre IP-Adresse, an Google übermittelt werden.
        Wenn Sie die Übertragung verhindern möchten, können Sie in Ihren Browsereinstellungen den Zugriff auf die Domain
        fonts.googleapis.com blockieren.
      </p>

      <h3>4.4 Hinweis zur Datenweitergabe in die USA</h3>
      <p>
        Auf unserer Website sind unter anderem Tools von Unternehmen mit Sitz in den USA eingebunden. Wenn diese Tools aktiv sind,
        können Ihre personenbezogenen Daten an die US-Server der jeweiligen Unternehmen weitergegeben werden. Wir weisen darauf hin,
        dass die USA kein sicherer Drittstaat im Sinne des EU-Datenschutzrechts sind.
      </p>

      <h3>4.5 Externes Hosting</h3>
      <p>
        Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, die auf dieser Website
        erfasst werden, werden auf den Servern des Hosters gespeichert. Der Einsatz des Hosters erfolgt zum Zwecke der
        Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden (Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO) und
        im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots durch einen professionellen
        Anbieter (Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO).
      </p>

      <h3>4.6 Lead-Magnet, Newsletter & On-Site-Tracking</h3>
      <p>
        Auf unserer Website bieten wir Ihnen die Möglichkeit, sich für unseren kostenlosen <strong>„Insider-Report"</strong> mit
        Marktanalysen, Strategie-Insights und Auszügen aus dem aktuellen Track Record einzutragen (Lead-Magnet-Popup bzw.
        Anmeldeformular). Bei der Anmeldung verarbeiten wir folgende Daten:
      </p>
      <ul>
        <li>Vorname (optional)</li>
        <li>E-Mail-Adresse</li>
        <li>Datum und Uhrzeit der Anmeldung</li>
        <li>technische Session-Kennung (für Statistik &amp; Spam-Schutz)</li>
      </ul>
      <p>
        Die Verarbeitung erfolgt auf Grundlage Ihrer ausdrücklichen Einwilligung gemäss Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;a DSGVO.
        Wir verwenden Ihre E-Mail-Adresse, um Ihnen den Insider-Report zuzustellen sowie weiterführende Informationen, Erinnerungen
        und Updates zu unserem Trading-System zu senden (sog. Drip-Sequenz, z.B. nach 3, 7 und 14 Tagen). Versanddienstleister ist
        <strong> Resend (Resend Inc., 2261 Market Street #4787, San Francisco, CA 94114, USA)</strong>. Mit Resend wurde ein
        Auftragsverarbeitungsvertrag (Data Processing Agreement) abgeschlossen; die Datenübermittlung in die USA erfolgt auf
        Grundlage der Standardvertragsklauseln der EU-Kommission.
      </p>
      <p>
        <strong>Widerruf &amp; Abmeldung:</strong> Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen,
        entweder über den Abmelde-Link in jeder unserer E-Mails oder per formlose Mitteilung an
        <a href="mailto:kontakt@moonshine-solutions.com"> kontakt@moonshine-solutions.com</a>. Nach dem Widerruf werden Ihre Daten
        aus dem Mailverteiler entfernt. Aus Gründen der Nachvollziehbarkeit erfolgter Einwilligungen können wir Anmelde-Logs
        (Zeitstempel, IP, sofern erfasst) bis zu drei Jahre aufbewahren.
      </p>
      <p>
        <strong>Privacy-freundliches On-Site-Tracking:</strong> Zur Optimierung unserer Website erheben wir aggregierte
        Nutzungsstatistiken (Seitenaufrufe, Verweildauer, Scroll-Tiefe, Klicks auf zentrale Schaltflächen). Hierzu wird im
        <code>localStorage</code> Ihres Browsers eine zufällig erzeugte Session-Kennung gespeichert. Diese Kennung enthält
        <strong> keine personenbezogenen Daten</strong>, wird <strong>nicht an Drittanbieter</strong> wie Google Analytics, Meta
        oder Hotjar übermittelt und dient ausschliesslich der internen Auswertung auf unseren eigenen Servern. Es werden keine
        Cookies im rechtlichen Sinne (Tracking-Cookies) gesetzt. Rechtsgrundlage ist unser berechtigtes Interesse an einer
        nutzerfreundlichen, performanten Website (Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO). Sie können das Tracking jederzeit
        durch Löschen Ihres Browser-Speichers oder Aktivieren des „Do Not Track"-Modus deaktivieren.
      </p>

      <p className="!mt-12 !text-sm !text-slate-500">Zuletzt aktualisiert: Februar 2026</p>
    </LegalLayout>
  );
}
